import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import '../../../scss/component/print-styles.scss';
import { fetchExamPrintPreview } from '../../../redux/actions/examActions';
import { createErrorMessage } from '../../../helpers/notification';
import { dateFormat, timeFormat } from '../../../helpers/dateFormat';
import {
  Calificaciones, InstanciaExamen,
} from '../../../constants/enums';

import LoadingSpinner from '../../../shared/components/LoadingSpinner';

class PreviewFormContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.fetchCurrentExam(InstanciaExamen.Final);
  }

  fetchCurrentExam = (instanciaExamen) => {
    const { id, history } = this.props;
    if (!id) {
      this.setState({
        exam: {
          id: 0,
          fecha: new Date().toISOString(),
        },
      });

      this.fetchDatasList();
      return;
    }

    fetchExamPrintPreview(id, instanciaExamen, {
      onSuccess: (exam) => {
        this.setState({ exam });
      },
      onError: (error) => {
        if (error && error.status === 404) {
          createErrorMessage('El examen no existe');
          history.push('/pages/exams');
        } else {
          createErrorMessage('Error al intentar cargar los datos del examen');
        }
      },
    });
  }

  handleOnBack = () => {
    const { history } = this.props;
    history.goBack();
  }

  getCalificacionText = (calificacion) => {
    const calificacionObj = Calificaciones.find(c => c.value === calificacion) || {};
    return calificacionObj.value ? calificacionObj.desciption : '-';
  }

  getObservacion = (calificacion) => {
    const calificacionObj = Calificaciones.find(c => c.value === calificacion) || {};
    return !calificacionObj.value ? calificacionObj.desciption : '';
  }

  render() {
    const { exam } = this.state;
    if (!exam) {
      return <LoadingSpinner />;
    }

    return (
      <Container>
        <Row>
          <Col md={12}>
            <div className="card__title">
              <button type="button" className="btn btn-primary" onClick={() => window.print()}>
                <i className="fa fa-print" /> Imprimir
              </button>
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={this.handleOnBack}
              >Cancelar - Volver
              </button>
            </div>

            <div
              id="section-to-print"
              className="section-to-print print-body"
              style={{
                fontFamily: 'sans-serif;',
                display: 'flex',
                justifyContent: 'center',
                width: 'auto',
              }}
            >
              <div style={{ display: 'grid', width: '100%', justifyContent: 'center' }}>
                <img
                  alt="Membrete FIUNI 2023"
                  className="logo-membrete-img"
                />
                <h3
                  style={{
                    fontFamily: 'Arial', fontWeight: 'bold', fontSize: '1.4rem', marginTop: '1.2rem',
                  }}
                >
                  {`ACTA ${exam.nroActa}`}
                </h3>
                <h3
                  style={{
                    fontFamily: 'Times New Roman', fontWeight: 'bold', fontSize: '1.4rem', marginTop: '0.1rem',
                  }}
                >
                  CARRERA DE INGENIER&Iacute;A {exam.carrera.toUpperCase()}
                </h3>

                <p
                  align="center"
                  style={{
                    marginBottom: '0cm', marginTop: '1rem', lineHeight: '100%', pageBreakAfter: 'avoid',
                  }}
                >
                  <font face="Arial, serif">
                    <font size="5" style={{ fontSze: '16pt' }}>
                      <u>
                        <b>{`EXAMEN ${exam.periodo}`.toUpperCase()} </b>
                      </u>
                    </font>
                  </font>
                </p>
                <p align="center" style={{ marginBottom: '0cm', lineHeight: '100%' }}>
                  <br />
                </p>
                <p
                  style={{
                    marginLeft: '1.25cm',
                    textIndent: '-1.25cm',
                    marginBottom: '0cm',
                    lineHeight: '150%',
                    textAlign: 'unset',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <span style={{ fontVariant: 'smallCaps' }}>
                    <sub>
                      <font face="Arial, serif">
                        <font size="4.5" style={{ fontSze: '18pt' }}>
                          <span>
                            <b>ASIGNATURA:</b>
                          </span>
                        </font>
                      </font>
                    </sub>
                    <sub>
                      <font face="Arial, serif">
                        <font size="4.5" style={{ fontSze: '18pt' }}>
                          <span>
                            {` ${exam.materia}`.toUpperCase()}
                          </span>
                        </font>
                      </font>
                    </sub>
                  </span>
                  <span style={{ fontVariant: 'smallCaps' }}>
                    <sub>
                      <font face="Arial, serif">
                        <font size="4.5" style={{ fontSze: '18pt' }}>
                          <span>
                            <b>
                              SEMESTRE:
                            </b>
                          </span>
                        </font>
                      </font>
                    </sub>
                    <sub>
                      <font face="Arial, serif">
                        <font size="4.5" style={{ fontSze: '18pt' }}>
                          <span>
                            {` ${exam.semestre}`.toUpperCase().replace('SEMESTRE', '').trimEnd()}
                          </span>
                        </font>
                      </font>
                    </sub>
                  </span>
                </p>
                <h5 className="profesor">
                  <font face="Arial, serif">
                    <font size="4.5" style={{ fontSze: '16pt' }}>
                      <span lang="en-US">
                        <b>
                          PROFESOR:
                        </b>
                      </span>
                    </font>
                  </font>
                  <font face="Arial, serif">
                    <font size="4.5" style={{ fontSze: '16pt' }}>
                      <span lang="en-US">
                        {` ${exam.profesor}`.toUpperCase()}
                      </span>
                    </font>
                  </font>
                </h5>
                <h5 className="profesor">
                  <font face="Arial, serif">
                    <font size="4.5" style={{ fontSze: '16pt' }}>
                      <span lang="en-US">
                        <b>INTERVENTOR:</b>
                      </span>
                    </font>
                  </font>
                  <font face="Arial, serif">
                    <font size="4.5" style={{ fontSze: '16pt' }}>
                      <span lang="es-ES">
                        {` ${exam.interventor}`.toUpperCase()}
                      </span>
                    </font>
                  </font>
                </h5>
                <h1
                  style={{
                    lineHeight: '150%', display: 'flex', justifyContent: 'space-between', marginBottom: '0.4rem',
                  }}
                >
                  <span style={{ fontVariant: 'small-caps' }}>
                    <sub>
                      <font face="Arial, serif">
                        <font size="4.5" style={{ fontSze: '18pt' }}>
                          <b>FECHA:</b>
                        </font>
                      </font>
                    </sub>
                    <sub>
                      <font face="Arial, serif">
                        <font size="4.5" style={{ fontSze: '18pt' }}>
                          {` ${dateFormat(exam.fecha)}`}
                        </font>
                      </font>
                    </sub>
                  </span>
                  <span style={{ fontVariant: 'small-caps' }}>
                    <sub>
                      <font face="Arial, serif">
                        <font size="4.5" style={{ fontSze: '18pt' }}>
                          <b>
                            HORA:
                          </b>
                        </font>
                      </font>
                    </sub>
                    <sub>
                      <font face="Arial, serif">
                        <font size="4.5" style={{ fontSze: '18pt' }}>
                          {` ${timeFormat(exam.fecha)}`}
                        </font>
                      </font>
                    </sub>
                  </span>
                </h1>
                <div>
                  <table id="table-break">
                    <thead>
                      <tr>
                        <td className="no-border">
                          {/* <!--place holder for the fixed-position header--> */}
                          <div className="page-header-space">
                            <p>{`ACTA ${exam.nroActa}`}</p>
                          </div>
                        </td>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td className="no-border">
                          {/* <!--*** CONTENT GOES HERE ***--> */}
                          <div className="page">
                            <table cellPadding="5" cellSpacing="1" style={{ width: '100%' }}>
                              <colgroup>
                                <col width="286" />
                                <col width="64" />
                                <col width="84" />
                                <col width="157" />
                              </colgroup>
                              <tbody>
                                <tr valign="top">
                                  <td
                                    rowSpan="2"
                                    width="286"
                                    height="15"
                                    style={{ padding: '0cm 0.12cm' }}
                                    className="content-end"
                                  >
                                    <h3>
                                      <font face="Arial, serif">
                                        <font size="3" style={{ fontSze: '12pt' }}>
                                          ALUMNOS
                                        </font>
                                      </font>
                                    </h3>
                                  </td>
                                  <td colSpan="2" width="159" style={{ padding: '0cm 0.12cm' }}>
                                    <h3>
                                      <font face="Arial, serif">CALIFICACI&Oacute;N</font>
                                    </h3>
                                  </td>
                                  <td rowSpan="2" width="157" style={{ padding: '0cm 0.12cm' }} className="content-end">
                                    <h3>
                                      OBSERVACI&Oacute;N
                                    </h3>
                                  </td>
                                </tr>
                                <tr valign="top">
                                  <td width="64" style={{ padding: '0cm 0.12cm' }}>
                                    <h3>N&Uacute;M.</h3>
                                  </td>
                                  <td width="84" style={{ padding: '0cm 0.12cm' }}>
                                    <h3>LETRAS</h3>
                                  </td>
                                </tr>
                                {exam.inscriptos.map((item, index) => (
                                  <tr key={item.id} className="item-inscripto">
                                    <td width="286" style={{ padding: '0cm 0.12cm' }}>
                                      <h4 className="text-start">
                                        {`${index + 1}. ${item.apellido}, ${item.nombre}`}
                                      </h4>
                                    </td>
                                    <td width="64" style={{ padding: '0cm 0.12cm' }}>
                                      <h4 style={{ textAlign: 'center', padding: '0 auto' }}>
                                        <span style={{ fontVariant: 'normal' }}>
                                          {` ${item.calificacion || '-'}`}
                                        </span>
                                      </h4>
                                    </td>
                                    <td width="84" style={{ padding: '0cm 0.12cm' }}>
                                      <h4 style={{ padding: '0 auto' }}>
                                        <span style={{ fontVariant: 'normal' }}>
                                          {` ${this.getCalificacionText(item.calificacion)}`}
                                        </span>
                                      </h4>
                                    </td>
                                    <td
                                      width="157"
                                      style={{ padding: '0cm 0.12cm' }}
                                      className={this.getObservacion(item.calificacion) ? '' : 'diagonal'}
                                    >
                                      <h4 style={{ padding: '0 auto' }}>
                                        <span style={{ fontVariant: 'normal' }}>
                                          {` ${this.getObservacion(item.calificacion)}`}
                                        </span>
                                      </h4>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          <div className="container-box">
                            <div className="box">
                              <div className="box-item text-left" style={{ width: '33.3%' }}>
                                <p>.....................</p>
                              </div>
                              <div className="box-item " style={{ width: '33.3%' }}>
                                <p>.....................</p>
                              </div>
                              <div className="box-item text-right" style={{ width: '33.3%' }}>
                                <p>.....................</p>
                              </div>

                              <div className="box-item text-left" style={{ width: '33.3%' }}>
                                <p>Interventor</p>
                              </div>
                              <div className="box-item " style={{ width: '33.3%' }}>
                                <p>Profesor</p>
                              </div>
                              <div className="box-item text-right" style={{ width: '33.3%' }}>
                                <p>Decano</p>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tfoot>
                      <tr>
                        <td>
                          {/* <!--place holder for the fixed-position footer--> */}
                          <div className="page-footer-space">page-footer-space</div>
                        </td>
                      </tr>
                    </tfoot>

                  </table>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

PreviewFormContainer.propTypes = {
  id: PropTypes.string.isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default PreviewFormContainer;
